import React, { useMemo } from 'react'
import Tab, { TabItem } from '@/components/tab/tab'
import { getBEMCls } from '@/utils/classname'
import { MainHeader, Column, Expaned } from '@/components/layout/layout'
import { RouteComponentProps } from 'react-router'
import { observer } from 'mobx-react'
import OrderContent, { ORDER_CASHIER, ORDER_MALL } from './router'

const Order = observer((props: RouteComponentProps) => {
    const tabList: TabItem[] = useMemo(
        () => [
            {
                id: 0,
                name: '门店',
                route: ORDER_CASHIER,
            },
            {
                id: 1,
                name: '微商城',
                route: ORDER_MALL,
            },
        ],
        [],
    )

    const getCls = (el?: string, m?: string) => getBEMCls('staff-manage', el, m)

    return (
        <Column className={getCls()}>
            <MainHeader>
                <Tab tabList={tabList} />
            </MainHeader>
            <Expaned className={getCls('content')}>
                <OrderContent {...props} />
            </Expaned>
        </Column>
    )
})

export default Order
